import {ApiModel} from './api-model';

export class ChartModel extends ApiModel {
  id: string;
  title: string;
  labels: string[];
  data: number[];
  type: string;
  percentTranslated: number;
  isDisplayed: boolean;
  isSportiveClassification: boolean;
  isMetadatasClassification: boolean;

  constructor(data: any) {
    super(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/chart-model.ts